import api from "../../Utils/interceptors";

export const getAllPettyPurchases =
  (
    page,
    size,
    request_by = "",
    accounts_status = "",
    priority = "",
    created_month = ""
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_ALL_PETTY_PURCHASES_REQUEST",
      });
      const { data } = await api.get(
        `petty-purchases/all?page=${page}&size=${size}&request_by=${request_by}&accounts_status=${accounts_status}&priority=${priority}&created_month=${created_month}`
      );
      dispatch({
        type: "GET_ALL_PETTY_PURCHASES_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_ALL_PETTY_PURCHASES_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const getCurrentUserPettyPurchases =
  (page, size, request_by = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_CURRENT_USER_PETTY_PURCHASES_REQUEST",
      });
      const { data } = await api.get(
        `petty-purchases/my?page=${page}&size=${size}&request_by=${request_by}`
      );
      dispatch({
        type: "GET_CURRENT_USER_PETTY_PURCHASES_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_CURRENT_USER_PETTY_PURCHASES_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const createPettyPurchase = (purchaseData) => async (dispatch) => {
  try {
    dispatch({
      type: "CREATE_PETTY_PURCHASE_REQUEST",
    });

    const { data } = await api.post("/petty-purchase/create", purchaseData);

    dispatch({
      type: "CREATE_PETTY_PURCHASE_SUCCESS",
      payload: data,
      success: true,
    });
  } catch (e) {
    dispatch({
      type: "CREATE_PETTY_PURCHASE_FAILED",
      payload: e.response.data.message,
      success: false,
    });
  }
};

export const getPettyPurchaseDetail = (purchase_id) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_PETTY_PURCHASE_DETAIL_REQUEST",
    });
    const { data } = await api.get(`/petty-purchase/${purchase_id}`);
    dispatch({
      type: "GET_PETTY_PURCHASE_DETAIL_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "GET_PETTY_PURCHASE_DETAIL_FAILED",
      payload: error.response?.data?.message,
    });
  }
};

export const deletePettyPurchase = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "DELETE_PETTY_PURCHASE_REQUEST",
    });
    const { data } = await api.delete(`/petty-purchase/${id}`);
    dispatch({
      type: "DELETE_PETTY_PURCHASE_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "DELETE_PETTY_PURCHASE_FAILED",
      payload: error.response?.data?.message,
    });
  }
};

export const updatePettyPurchaseStatus =
  (purchase_id, status, approverType) => async (dispatch) => {
    try {
      dispatch({
        type: "UPDATE_PETTY_PURCHASE_STATUS_REQUEST",
      });
      const { data } = await api.put(
        `/petty-purchase/confirmation/${purchase_id}`,
        {
          status,
          approverType,
        }
      );
      dispatch({
        type: "UPDATE_PETTY_PURCHASE_STATUS_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "UPDATE_PETTY_PURCHASE_STATUS_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const sendPettyPurchaseComment =
  (purchase_id, comment) => async (dispatch) => {
    try {
      dispatch({
        type: "SEND_PETTY_PURCHASE_COMMENT_REQUEST",
      });
      const { data } = await api.put(`/petty-purchase/comment/${purchase_id}`, {
        comment,
      });
      dispatch({
        type: "SEND_PETTY_PURCHASES_COMMENT_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "SEND_PETTY_PURCHASES_COMMENT_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };
